var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgZa = function SvgZa(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 480,
    width: 640,
    viewBox: "0 0 640 480"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.67,
    d: "M-71.873-.012h682.68v512.01h-682.68z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    transform: "translate(67.379 .011) scale(.93748)"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    strokeWidth: "1pt"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-71.878 407.837V104.428l225.832 151.627-225.832 151.793z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.217 512.121l253.538-170.644h360.372v170.644H82.217z",
    fill: "#00c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.917.062l630.19.013v170.672H335.735S69.295-1.626 65.917.062z",
    fill: "red"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-71.878 64.075v40.329L153.954 256.03-71.878 407.823v40.327l284.44-192.12-284.44-191.955z",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-71.878 64.075V.062h94.891l301.313 203.88h371.778v104.261H324.326L23.013 512.053h-94.89V448.15l284.439-192.12-284.44-191.955z",
    fill: "#093"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.013.062h59.194l253.538 170.673h360.372v33.207H324.339L23.025.062zM23.013 512.121h59.194l253.538-170.644h360.372v-33.206H324.339L23.025 512.12z",
    fill: "#fff"
  })))));
};
export default __webpack_public_path__ + "assets/94f5133a891492cec7bde5017ec77f57.svg";
export { SvgZa as ReactComponent };


// WEBPACK FOOTER //
// ./assets/images/flags/4x3/za.svg